
<template>
  <div
    class="
      h-screen
      flex
      w-full
      bg-img
      vx-row
      no-gutter
      items-center
      justify-center
    "
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <div class="text-center">
        <img
          class="image-responsive textcenter admin_logo mb-8"
          src="@/assets/images/logo/hobi_logo.png"
        />
      </div>
      <form @submit.prevent="sendLink()" autocomplete="off">
        <vx-card>
          <div slot="no-body" class="page-bg-color p-8">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2 inner_image">
                <img
                  src="@/assets/images/full-pages/Login.png"
                  alt="forget"
                  class="mx-auto"
                />
              </div>

              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div class="p-8 login-tabs-container">
                  <div class="vx-card__title mb-4">
                    <h4 class="mb-8">{{ $t("labels.heading_OTP") }}</h4>
                  </div>

                  <div>
                    <vs-input
                      name="otp"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      :label-placeholder="$t('labels.input_otp')"
                      v-model="otp"
                      class="w-full mb-2"
                      v-validate="'required|numeric|length:6'"
                    />
                    <span class="text-danger text-sm">{{
                      errors.first("otp")
                    }}</span>
                    <div class="mt-5 forget_link">
                      <a style="cursor: pointer" @click="resendOtp()">{{
                        $t("labels.resend_otp")
                      }}</a>
                      <vs-button
                        :disabled="button_loading"
                        id="forgot-password"
                        button="submit"
                        class="
                          vs-component vs-button
                          float-right
                          px-4
                          w-full
                          md:w-auto
                          mb-8
                          md:mt-0
                          md:mb-0
                          vs-button-primary vs-button-filled
                        "
                        >{{ $t("labels.submit") }}</vs-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      otp: "",
      email: localStorage.getItem("admin-email"),
    };
  },

  mounted() {
    this.setValidationMessage();
    if (localStorage.getItem("reset-password-visited")) {
      this.$router.push("/admin/login");
    }
  },

  methods: {
    sendLink() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.button_loader(true, "#forgot-password");
          let input = {
            email: this.email,
            otp: this.otp,
          };
          axios
            .post("user/checkOtp", input)
            .then((response) => {
              this.button_loader(false, "#forgot-password");
              let data = response.data;
              this.$vs.notify({
                text: data.message,
                color: "success",
                position: "top-right",
              });
              localStorage.setItem("change-password", true);
              this.$router.push({ name: "ResetPassword" });
            })
            .catch((e) => {
              this.showError(e, "#forgot-password");
            });
        }
      });
    },
    resendOtp() {
      // this.button_loader(true, "#forgot-password");
      let input = {
        email: this.email,
        // otp:this.otp
      };
      axios
        .post("user/sendEmailVerificationOtp", input)
        .then((response) => {
          this.button_loader(false, "#forgot-password");
          let data = response.data;
          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });
        })
        .catch((e) => {
          this.showError(e, "#forgot-password");
        });
    },
  },
};
</script>

<style lang="scss">
</style>
